import Vue from 'vue';

import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';

import { required, regex } from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: 'Este campo é obrigatório.', 
});

extend('regex', {
  ...regex,
  message: 'Formato inválido. Insira 10 ou 11 dígitos numéricos (DDD+Telefone).', 
});

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

console.log('VeeValidate components and rules registered globally.');